import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Timespending } from '@/app.context/workspace/Event';
import { EffortRmodel, Timeffort } from '@/app.context/workspace/persons/sunrises/effort.rmodel'
import { Direction, SegmentEnd } from '@/logic/_infra/_tech';
import { TimeSegment } from '@/logic/_infra/time';
import {emits, offset as offset_f} from '@/components/Workspaces/persons/_spec/timeline/clock_timeline'
import TimesegmentComponent from '@/components/Workspaces/_infra/time/TimesegmentComponent.vue'
//C:\Work\mailnum\web.mn\src\components\Workspaces\_infra\time\TimesegmentComponent.vue


import dayjs from 'dayjs'
import utc  from 'dayjs/plugin/utc'



export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineFullSubClocksComponent',
  props: {
    segment: {},
    item: {},
    timeffort: {},
    timespending: {},
    offset: {}
  },
  emits: emits,
  setup(__props: any, { emit: __emit }) {


const props = __props

// const emit = defineEmits({
//     "click"(d: Direction, e: SegmentEnd, effort: EffortRmodel, timeffort: Timeffort | null, timespending: Timespending | null) {

//         return true
//     }
// })

const emit = __emit

function click(d: Direction, e: SegmentEnd) {

    emit("click", d, e, props.item,  props.timeffort, props.timespending)
}

const offset = offset_f(props)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createVNode(TimesegmentComponent, {
      segment: props.segment,
      offset: props.offset,
      onClick: click
    }, null, 8, ["segment", "offset"])
  ]))
}
}

})